import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link, useLocation } from "react-router-dom";
import { MdCardMembership, MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaBriefcase, FaInfinity } from "react-icons/fa";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";

import {
  Search,
  CheckCircle,
  ArrowRight,
  FileText,
  UploadCloud,
  CreditCard,
  BadgePercent,
} from "lucide-react";
import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import {
  FaGasPump,
  FaGift,
  FaCashRegister,
  FaRedo,
  FaShoppingCart,
  FaUtensils,
} from "react-icons/fa";
import { Building2, Wallet, Gift, ShoppingBag } from "lucide-react";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const Fuel = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Fuel")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "What is the main benefit of using a fuel credit card?",
      answer:
        " Fuel credit cards help you save on petrol or diesel costs through surcharge waivers, cashback, and reward points tailored for fuel purchases.",
    },
    {
      question:
        "Do I need to use my fuel credit card only at specific petrol pumps?",
      answer:
        "Yes, many cards are tied to specific fuel station networks like Indian Oil, HPCL, or BPCL. Using them at designated stations maximizes your benefits.",
    },
    {
      question: " Can I use a fuel credit card for non-fuel purchases?",
      answer:
        " Absolutely. While fuel benefits are the highlight, these cards also offer rewards and deals on dining, shopping, and more.",
    },
    {
      question: "Are fuel surcharge waivers unlimited?",
      answer:
        " No. Typically, the 1% surcharge waiver is capped at ₹250 to ₹500 per statement cycle, depending on the bank and card.",
    },
    {
      question: " Is there an annual fee for fuel credit cards?",
      answer:
        " Yes, but many cards waive the fee if you meet annual spending milestones, often around ₹30,000–₹50,000.",
    },
    {
      question: "Can I convert my fuel spends into EMIs?",
      answer:
        "  Yes, some issuers allow EMI conversions on higher fuel bills or related auto expenses via netbanking or customer service.",
    },

    {
      question: "  Will my fuel card affect my credit score?",
      answer:
        "  Yes, just like any credit card. Timely payments improve your credit score, while defaults or delays may impact it negatively.",
    },

    {
      question: " How soon can I get my card after applying?",
      answer:
        "  Upon successful verification, most banks deliver the card within 7 to 10 working days.",
    },

    {
      question: "Which fuel brands are commonly partnered with fuel credit cards?",
      answer: "Most fuel credit cards are co-branded with major oil companies like Indian Oil, Bharat Petroleum, or Hindustan Petroleum. These partnerships often offer higher reward points and better surcharge waivers when used at partner fuel stations."
    },
    {
      question: "Do fuel credit cards offer cashback or reward points?",
      answer: "Yes, fuel credit cards often provide cashback, reward points, or loyalty benefits on fuel purchases. These rewards can later be redeemed for discounts, statement credits, or vouchers depending on the card issuer."
    },
    {
      question: "What is the average fuel surcharge waiver limit per month?",
      answer: "The monthly fuel surcharge waiver typically ranges between ₹250 to ₹500, depending on the card. It's important to check your card's terms to know the exact cap on surcharge waivers."
    },
    {
      question: "Is KYC verification required for applying for a fuel credit card?",
      answer: "Yes, all credit card applications in India require KYC (Know Your Customer) verification. This includes providing identity proof, address proof, and sometimes income proof as per RBI regulations."
    },
    {
      question: "Can I upgrade my regular credit card to a fuel card?",
      answer: "In many cases, card issuers allow upgrades or conversions based on your usage and credit profile. You can contact your bank to check if you're eligible to switch to a fuel credit card or apply separately."
    },
    {
      question: "Are fuel credit cards beneficial for daily commuters?",
      answer: "Absolutely. Daily commuters who spend frequently on fuel can save significantly through cashback, reward points, and surcharge waivers, making these cards highly suitable for regular users."
    },
    {
      question: "Can I apply for more than one fuel credit card?",
      answer: "Yes, you can apply for multiple fuel credit cards from different issuers. However, make sure you manage them responsibly, as too many cards can impact your credit score if not handled well."
    },
    {
      question: "Do fuel credit cards offer roadside assistance or auto-related benefits?",
      answer: "Some premium fuel credit cards include additional perks like roadside assistance, vehicle servicing discounts, or insurance cover. These benefits vary by card, so it’s good to compare features."
    },
    {
      question: "Is there a minimum fuel transaction amount to avail surcharge waiver?",
      answer: "Yes, most cards specify a minimum fuel transaction amount, typically ₹400, to qualify for the surcharge waiver. Transactions below this limit may not be eligible for any benefits."
    },
    {
      question: "How can I track my fuel credit card rewards?",
      answer: "Rewards can be tracked through your credit card’s official app, online banking portal, or monthly statements. Many issuers provide a breakdown of earned, redeemed, and expiring points for easy tracking."
    }
  ];

  const steps = [
    {
      icon: <BadgePercent className="h-6 w-6 text-orange-500" />,
      title: "Choose the Right Card",
      description:
        "Once you've evaluated your options, select a card that matches your fuel spending habits, preferred fuel provider, and additional lifestyle benefits such as dining, shopping, or travel rewards.",
    },
    {
      icon: <CheckCircle className="h-6 w-6 text-green-500" />,
      title: "Check Eligibility",
      description:
        "Each card comes with a set of eligibility requirements based on income, age, employment status, and credit history. Make sure to review these criteria before proceeding further.",
    },
    {
      icon: <ArrowRight className="h-6 w-6 text-purple-600" />,
      title: "Click to Apply",
      description:
        "When you’re ready, click the ‘Apply Now’ button on your chosen card. You’ll be securely redirected to the official website of the issuing bank or financial institution to initiate your application.",
    },
    {
      icon: <FileText className="h-6 w-6 text-teal-500" />,
      title: "Fill in the Application Form",
      description:
        "On the bank’s page, complete the application form by submitting your personal details, income information, and employment history as per their requirements.",
    },
    {
      icon: <UploadCloud className="h-6 w-6 text-amber-500" />,
      title: "Upload Required Documents",
      description:
        "Submit digital copies of your KYC documents like PAN card, Aadhaar card, income proof, and address verification, as requested by the issuer.",
    },
    {
      icon: <CreditCard className="h-6 w-6 text-pink-500" />,
      title: "Verification and Card Issuance",
      description:
        "Once submitted, the bank will process your application, verify your credentials, and upon approval, dispatch the credit card to your registered address—usually within 7–10 business days.",
    },
    {
      icon: <Search className="h-6 w-6 text-blue-600" />,
      title: "Research and Compare",
      description:
        "Begin by exploring our curated selection of top fuel credit cards on TheFinMaster.com. We help you compare cards based on factors like fuel station compatibility (IOCL, HPCL, BPCL, etc.), cashback structure, reward redemption options, and annual fees — so you make an informed choice tailored to your lifestyle.",
    },
  ];
  const benefits = [
    {
      icon: <FaGasPump className="text-3xl text-blue-600" />,
      title: "Fuel Surcharge Waiver",
      description:
        "Enjoy a 1% fuel surcharge waiver on transactions at select petrol pumps, saving you money on every refill.",
    },
    {
      icon: <FaGift className="text-3xl text-green-600" />,
      title: "Accelerated Reward Points",
      description:
        "Earn 4x to 6x reward points on fuel transactions, redeemable for cashback, vouchers, or products.",
    },
    {
      icon: <FaCashRegister className="text-3xl text-yellow-500" />,
      title: "Cashback Offers",
      description:
        "Get up to 5% cashback on fuel purchases, especially when used at partnered stations.",
    },
    {
      icon: <FaRedo className="text-3xl text-purple-600" />,
      title: "Annual Fee Waivers",
      description:
        "Enjoy annual fee reversals on meeting yearly spending thresholds, making the card practically free.",
    },
    {
      icon: <FaUtensils className="text-3xl text-red-500" />,
      title: "Additional Lifestyle Benefits",
      description:
        "Benefit from discounts on dining, shopping, travel bookings, and more.",
    },
    {
      icon: <FaShoppingCart className="text-3xl text-pink-500" />,
      title: "EMI Conversion Options",
      description:
        "Convert high fuel or vehicle spends into EMIs with lower interest rates.",
    },
  ];
  const factors = [
    {
      icon: BadgePercent,
      title: "Savings on Fuel Transactions",
      desc: "The core purpose of a fuel credit card is to reduce your fuel expenses. Look at the cashback percentage or reward rate the card offers on fuel spends. Opt for a card that helps you earn noticeable monthly savings based on your regular fuel consumption, ideally without high minimum spend conditions.",
    },
    {
      icon: Building2,
      title: "Partnered Oil Companies",
      desc: "Many fuel credit cards are tied to specific fuel providers like Indian Oil, HPCL, or BPCL. It’s essential to check whether the card offers benefits only at selected fuel stations or across all fuel brands. Your savings are maximized when the card aligns with your most frequently visited petrol pumps.",
    },
    {
      icon: BadgePercent,
      title: "Fuel Surcharge Waiver",
      desc: "Most fuel cards offer a 1% fuel surcharge waiver, but the conditions vary. Review the eligible transaction range, monthly cap, and whether the waiver includes taxes like GST. A flexible and inclusive waiver can significantly improve your effective savings.",
    },
    {
      icon: Wallet,
      title: "Spending Thresholds",
      desc: "To unlock certain benefits or fee waivers, cards may require you to meet specific monthly or annual spending limits. Choose a card whose thresholds match your lifestyle and fuel spending habits so you don’t miss out on potential savings or perks.",
    },
    {
      icon: CreditCard,
      title: "Annual Fees & Waiver Conditions",
      desc: "Some fuel credit cards come with an annual fee, while others may waive it if you meet a spend milestone. It’s important to balance the fee with the benefits offered. Cards that provide a first-year waiver and an achievable spend target for renewal can offer better long-term value.",
    },
    {
      icon: Gift,
      title: "Reward Redemption Process",
      desc: "A card’s rewards are only as good as the ease with which you can redeem them. Look for cards that offer quick, hassle-free redemption—preferably instant redemptions at fuel stations or seamless conversions via the bank’s app or website.",
    },
    {
      icon: ShoppingBag,
      title: "Additional Lifestyle Benefits",
      desc: "Beyond fuel, many cards offer added value through dining, travel, or shopping offers. If you're looking for a card that goes beyond just savings at the pump, consider one that provides a balanced set of perks across your lifestyle needs.",
    },
  ];
  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  const ad = {
    image: "/assets/homeadd.png",
    link: "https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share",
    altText: "Advertisement",
  };
  return (
    <>
      <Helmet>
        <title>
          Best Fuel Credit Cards in India 2024 | Apply Now &amp; Earn Free Fuel!
        </title>
        <meta
          name="description"
          content="Find the updated list of best fuel credit cards in India 2024. Read about their fees, charges and benefits to find the best credit card for fuel."
        />
        <meta
          name="keywords"
          content="best credit card for fuel, petrol cards, indianoil axis bank credit card, bpcl sbi credit card, indian oil hdfc credit card, fuel surcharge on credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/fuel-credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />

      
      <div className="w-full flex justify-center items-center px-4 mt-20">
          <a
            href={ad.link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-5xl"
          >
            <img
              src={ad.image}
              alt={ad.altText}
              className="w-full h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105"
            />
          </a>
        </div>
      <div className="w-full flex flex-col items-center ">
        {/* <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
                <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
                    Fuel Card
                </h1>
                <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
               
            </div> */}
        <div className=" mt-8 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            Fuel Card
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>

        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-2 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-4 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-premium-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdStars className="mr-1 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Premium
              </span>
            </span>
          </Link>
            <Link
                      to="/credit-card/reward-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <FaGift className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        Reward
                        </span>
                      </span>
                    </Link>
                    <Link
                      to="/credit-card/business-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <FaBriefcase className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        Business
                        </span>
                      </span>
                    </Link>
                    <Link
                      to="/credit-card/lifestyle-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <MdCardMembership className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                          LifeStyle
                        </span>
                      </span>
                    </Link>
        </div>
        <h1 className="text-center font-bold text-2xl md:text-3xl my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          {/* <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between">
              <div className="w-[70%] mx-auto">
                <h2 className="text-center font-medium pt-5 text-lg">
                  <span className="font-semibold text-white">816 people</span>{" "}
                  are on call with our advisors right now
                </h2>
              </div>
              <div className="w-full mx-auto">
                <div className="w-[70%] mx-auto">
                  <img
                    src="https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png"
                    alt="imgg"
                  />
                </div>
                <div className="bg-white">
                  <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                    Know your advisor
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div> */} 
        <div className="w-full relative ">
                    <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                      {/* <div className="w-[70%] mx-auto">
                        <h2 className="text-center font-medium pt-5 text-lg">
                          <span className="font-semibold text-white">816 people</span>{" "}
                          are on call with our advisors right now
                        </h2>
                      </div> */}
                      <div className="w-full mx-auto">
                        <Link to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"     target="_blank"
            rel="noopener noreferrer">
                          <div className="w-[80%] mx-auto ">
                            <img
                              src="/assets/neoside.png"
                              alt="Advertisement"
                           
                            />
                          </div>
                        </Link>
                        <div className="bg-white">
                          {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                            Know your advisor
                          </h3> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            What is a Fuel Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A Fuel Credit Card is a specialized credit card designed to provide
            users with savings and rewards specifically on fuel purchases. These
            cards offer cashback, reward points, surcharge waivers, and
            exclusive discounts at partnered petrol pumps such as Indian Oil,
            BPCL, or HPCL. Ideal for frequent commuters and long-distance
            travelers, fuel credit cards not only help in reducing monthly fuel
            expenses but also come with added benefits such as accelerated
            reward programs and discounts on other lifestyle categories. By
            strategically using a fuel credit card, you can turn your routine
            refueling into a smart financial decision.{" "}
          </p>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for a Fuel Credit Card
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a fuel credit card is a seamless process that starts with
          the right research and ends at the official bank’s platform for final
          submission. Here’s how you can get started through TheFinMaster.com:
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for a Fuel Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Identity Proof
                </span>
                <span> PAN card, Aadhaar card, or passport.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Address Proof
                </span>
                <span> Utility bills, rental agreement, or Aadhaar card.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Income Proof
                </span>
                <span>
                  {" "}
                  Latest salary slips (for salaried individuals), ITR or bank
                  statements (for self-employed).
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Photograph
                </span>
                <span> Passport-sized photo as required by the issuer.</span>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Eligibility Required to Get the Fuel Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Minimum Age
                </span>
                <span>
                  {" "}
                  21 years for salaried individuals, 25 years for self-employed.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Maximum Age
                </span>
                <span>
                  {" "}
                  60 years for salaried, up to 65 for self-employed applicants.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Income Criteria
                </span>
                <span>
                  {" "}
                  A minimum monthly income of ₹20,000 to ₹30,000 (varies by
                  bank).{" "}
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Credit Score
                </span>
                <span>
                  {" "}
                  A good credit score of 700+ is generally preferred for
                  approval.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Employment Status
                </span>
                <span>
                  {" "}
                  Stable job or business continuity of at least 1 year.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Benefits of a Fuel Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6">
          How to Choose the Best Fuel Credit Card – Key Factors to Consider
        </h2>
        <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
          Selecting the right fuel credit card goes beyond just fuel discounts.
          It’s about ensuring consistent savings, ease of use, and long-term
          value. Here are the key elements to evaluate before making your
          choice:
        </p>

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
          Why Opt for a Fuel Credit Card?
        </h2>

        {/* Benefits List */}
        <ul className="text-base md:text-lg list-none space-y-4 mb-10 max-w-7xl mx-auto">
          <li className="flex gap-3 items-start">
            <span className="text-blue-600 mt-1.5">•</span>
            <span>
              <span className="font-semibold">Daily commuters</span> who spend
              significantly on petrol or diesel each month.
            </span>
          </li>
          <li className="flex gap-3 items-start">
            <span className="text-blue-600 mt-1.5">•</span>
            <span>
              <span className="font-semibold">
                Professionals or sales personnel
              </span>{" "}
              who travel frequently for work.
            </span>
          </li>
          <li className="flex gap-3 items-start">
            <span className="text-blue-600 mt-1.5">•</span>
            <span>
              <span className="font-semibold">
                Families with multiple vehicles,
              </span>{" "}
              especially in urban areas.
            </span>
          </li>
          <li className="flex gap-3 items-start">
            <span className="text-blue-600 mt-1.5">•</span>
            <span>
              <span className="font-semibold">
                Budget-conscious individuals
              </span>{" "}
              looking to save on unavoidable expenses like fuel.
            </span>
          </li>
          <li className="flex gap-3 items-start">
            <span className="text-blue-600 mt-1.5">•</span>
            <span>
              <span className="font-semibold">
                People living in tier-2/tier-3 cities
              </span>{" "}
              where public transport options may be limited.
            </span>
          </li>
        </ul>

        <p className="text-base md:text-lg text-center mb-14 max-w-4xl mx-auto">
          If your monthly fuel expenses exceed ₹3,000–₹5,000, opting for a fuel
          credit card can bring substantial monthly savings and added perks.
        </p>

        {/* Comparison Table */}
        <h3 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Fuel Credit Card vs Regular Credit Card
        </h3>

        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                [
                  "Fuel Benefits",
                  "High rewards, surcharge waivers",
                  "Minimal or none",
                ],
                ["Cashback on Fuel", "3–5% typically", "Rare"],
                [
                  "Reward Points",
                  "Accelerated on fuel spends",
                  "General reward program",
                ],
                ["Annual Fee", "Often lower or waived", "Varies"],
                [
                  "Redemption Options",
                  "Fuel & utility oriented",
                  "Lifestyle rewards",
                ],
                [
                  "Best For",
                  "Frequent drivers & vehicle owners",
                  "General spending",
                ],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-sm text-gray-700">
                    <p>
                      <span className="font-semibold">Fuel Card:</span> {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">Regular Card:</span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                      Fuel Credit Card
                    </th>
                    <th className="px-4 py-3 font-semibold">
                      Regular Credit Card
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "Fuel Benefits",
                      "High rewards, surcharge waivers",
                      "Minimal or none",
                    ],
                    ["Cashback on Fuel", "3–5% typically", "Rare"],
                    [
                      "Reward Points",
                      "Accelerated on fuel spends",
                      "General reward program",
                    ],
                    ["Annual Fee", "Often lower or waived", "Varies"],
                    [
                      "Redemption Options",
                      "Fuel & utility oriented",
                      "Lifestyle rewards",
                    ],
                    [
                      "Best For",
                      "Frequent drivers & vehicle owners",
                      "General spending",
                    ],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Fuel;

// import React, { useEffect, useState } from 'react'
// import CardComponent from '../cardComponents/CardComponent'
// import AccordionComponent from '../accordion/AccordionComponent'
// // import { CreditCardData } from './CardData'
// import Http from '../../Http'
// import { CARD_API } from '../../Helper'
// import { Link, useLocation } from 'react-router-dom'
// const Fuel = () => {
//     const [CreditCardData,setCreditCardData] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const [cardsPerPage] = useState(10);
//     const location = useLocation();
//     const cardData = location.state;
//     console.log(cardData, location.state)

//     const indexOfLastCard = currentPage * cardsPerPage;
//     const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//     //console.log({indexOfLastCard,indexOfFirstCard})
// //     console.log("cardData:", cardData);
// // const currentCards = cardData && cardData.filter((card) => card.category_name === "Fuel").slice(indexOfFirstCard, indexOfLastCard);
// // console.log("currentCards:", currentCards);
// console.log({cardData})
//     const currentCards = Array.isArray(cardData) && cardData.filter((cards)=>cards.category_name==="Fuel").slice(indexOfFirstCard, indexOfLastCard);
//     console.log({currentCards})

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <div className='w-full flex flex-col items-center '>

//             <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
//                 <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
//                     Fuel Card
//                 </h1>
//                 <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
//                 {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}

//             </div>

//             <h1 className='text-center font-bold text-5xl my-10'>Featured Credit Cards</h1>
//             <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10'>
//                 <div className='w-fit flex flex-col gap-8'>
//                     {
//                         currentCards &&
//                         currentCards.map((item, index) => {
//                             return <> <CardComponent key={index} cardDetails={item} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
//                         })
//                     }
//                 </div>

//                 <div className='w-full relative '>
//                     <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
//                         <div className='w-[70%] mx-auto'>
//                             <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
//                         </div>
//                         <div className='w-full mx-auto'>
//                             <div className='w-[70%] mx-auto'>
//                                 <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
//                             </div>
//                             <div className='bg-white'>
//                                 <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             </div>
//                    {/* Pagination */}
//                    <ul className='flex justify-center mt-4'>
//                 {currentCards &&
//                      CreditCardData.cards?.filter((card)=>card.category==="Credit card").length > 0 &&
//                     Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) > 1 &&
//                     Array.from({ length: Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) }).map((_, index) => (
//                         <li key={index} className='mx-1'>
//                             <button
//                                 className={`px-3 py-1 rounded-lg ${
//                                     currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
//                                 }`}
//                                 onClick={() => paginate(index + 1)}
//                             >
//                                 {index + 1}
//                             </button>
//                         </li>
//                     ))}
//             </ul>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//     )
// }

// export default Fuel
